module.exports = __webpack_public_path__ + "media/store/images/bx-phone-6689a421a51c0fea02fbaad14fb0a359.svg";